import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Root from './Root';

ReactDOM.render(<Root />, document.getElementById('root'));
